module.exports = __webpack_public_path__ + "static/media/screen projet3.9cfbeed7.PNG";